import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { Keyboard } from "@capacitor/keyboard";
import { StatusBar } from "@capacitor/status-bar";

export const isNativeApp = Capacitor.isNativePlatform();

const routeFromUrl = (value = "") => {
  try {
    const url = new URL(value);
    if (!["badminta.com", "www.badminta.com"].includes(url.hostname)) return "";
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return "";
  }
};

const navigateWithinApp = (path) => {
  if (!path) return;
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
};

export const initializeNativeAppShell = async () => {
  if (!isNativeApp || typeof window === "undefined") return;

  document.documentElement.classList.add("native-app");
  document.body.classList.add(`native-${Capacitor.getPlatform()}`);

  const hideNativeStatusBar = () => StatusBar.hide().catch(() => undefined);
  await hideNativeStatusBar();
  if (Capacitor.getPlatform() === "android") await StatusBar.setOverlaysWebView({ overlay: true }).catch(() => undefined);

  const launchUrl = await App.getLaunchUrl().catch(() => undefined);
  navigateWithinApp(routeFromUrl(launchUrl?.url));
  App.addListener("appUrlOpen", ({ url }) => navigateWithinApp(routeFromUrl(url)));
  App.addListener("appStateChange", ({ isActive }) => {
    if (isActive) hideNativeStatusBar();
  });
  App.addListener("backButton", ({ canGoBack }) => {
    if (canGoBack || window.history.length > 1) window.history.back();
    else App.minimizeApp();
  });
  Keyboard.addListener("keyboardWillShow", () => document.body.classList.add("native-keyboard-open"));
  Keyboard.addListener("keyboardWillHide", () => document.body.classList.remove("native-keyboard-open"));
};
